import React, { useState } from "react";
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { http } from "middleware/apiMiddleware";
import Button from "components/Buttons/Button";
import InputField from "components/FormFields/InputField";
import toast from "react-hot-toast";
import { CardPurposeEnum } from "enum/common";

interface IActivateOfferAddCardFormProps {
  clientSecret: string;
  onSuccess: (business: BusinessType) => void;
  selectedBusiness: BusinessType | null;
}

const ActivateOfferAddCardForm: React.FC<IActivateOfferAddCardFormProps> = ({
  clientSecret,
  onSuccess,
  selectedBusiness,
}) => {
  //state
  const [cardHolderName, setCardHoldername] = useState("");
  const [isUpdatingCard, setIsUpdatingCard] = useState(false);
  // hooks
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event: any) => {
    try {
      event.preventDefault();
      if (!stripe || !elements || isUpdatingCard) {
        return;
      }
      setIsUpdatingCard(true);
      const cardElement = elements.getElement(CardNumberElement);
      //  Setup Intent
      if (cardElement) {
        const { setupIntent, error } = await stripe.confirmCardSetup(
          clientSecret,
          {
            payment_method: {
              card: cardElement,
              billing_details: {
                name: cardHolderName.trim(),
              },
            },
          }
        );
        // send paymentMethodId to backend
        if (setupIntent && !error) {
          const { data, error } = await http.post(
            `/business/${selectedBusiness?.uuid}/cards`,
            {
              paymentMethodId: setupIntent.payment_method,
              makeDefault: true,
              purpose: CardPurposeEnum.ADD_PAYMENT,
            }
          );
          if (data && !error) {
            onSuccess(data?.customer?.entity);
          } else {
            toast.error(error || "Error occured while updating card");
          }
        }
      }
    } catch (error) {
      toast.error("Error occured while updating card");
    } finally {
      setIsUpdatingCard(false);
    }
  };

  const options2 = {
    showIcon: true,
    style: {
      base: {
        maxWidth: "200px",
        padding: "20px",
        minHeight: 201,
        backgroundColor: "white",
        lineHeight: "40px",
        color: "#424770",
        letterSpacing: "0.025em",
      },
      invalid: {
        color: "#9e2146",
        border: "1px solid red",
      },
    },
  };

  const inputStyle = `border border-black20 rounded-md mt-2  px-4 font-poppins md:flex-1 `;
  const labelText = `text-sm font-medium text-gray-900 text-opacity-80`;

  return (
    <form
      onSubmit={handleSubmit}
      className="h-full flex flex-col !m-0 "
      id="activate-promotion-add-card-form"
    >
      <div className="gap-2 flex-1 flex-grow">
        <div className="grid md:grid-cols-2 md:gap-x-4  gap-y-4">
          <InputField
            containerClass="!mb-0"
            customClass={`${inputStyle} !mb-[0px]`}
            placeholder="John Doe"
            onChange={function (e: any): void {
              setCardHoldername(e.target.value);
            }}
            value={cardHolderName}
            label={"Name on card"}
            id={""}
          />
          <div>
            <div className={labelText}>Card Number</div>
            <CardNumberElement className={inputStyle} options={options2} />
          </div>
          <div>
            <div className={labelText}>Expiry</div>
            <CardExpiryElement className={inputStyle} options={options2} />
          </div>
          <div>
            <div className={labelText}>CVC</div>
            <CardCvcElement className={inputStyle} options={options2} />
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 bg-white border-top shadow-lg">
        {/* <div className="flex gap-2 items-center mt-4">
          <InfoFilled className="text-warning mb-2 text-2xl md:text-xl mt-1" />
          <p className="!text-warning md:text-sm text-xs font-semibold">
            You will not be charged until{" "}
            {moment
              .utc(selectedBusiness?.preSignupDetails?.activationDate)
              .format("MMM Do, YYYY")}
            .
          </p>
        </div> */}
        <div className="w-full justify-end md:items-end items-center md:flex-row flex-col-reverse flex md:gap-2 mt-2">
          <Button
            form={"activate-promotion-add-card-form"}
            label="Activate"
            type="submit"
            customClass="md:w-[150px] !text-md w-[95%] !me-0"
            disabled={isUpdatingCard}
            loading={isUpdatingCard}
          />
        </div>
      </div>
    </form>
  );
};

export default ActivateOfferAddCardForm;
